import React, { useEffect } from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import { CheckCircleIcon, XCircleIcon, ClockIcon } from '@heroicons/react/24/outline';
import './booking-shared.css';
import './checkout.css';
import NotificationPrompt from '../../components/notifications/NotificationPrompt';

export default function BookingConfirmation() {
  const [searchParams] = useSearchParams();
  const redirectStatus = searchParams.get('redirect_status');

  useEffect(() => {
    // Clear cart once payment succeeds (Stripe redirect back to this page)
    if (redirectStatus === 'succeeded') {
      sessionStorage.removeItem('booking-cart');
      window.dispatchEvent(new CustomEvent('booking-cart-update'));
    }
  }, [redirectStatus]);

  // Payment failed or was cancelled
  if (redirectStatus && redirectStatus !== 'succeeded' && redirectStatus !== 'processing') {
    return (
      <div className="bk-page bk-page--narrow checkout-done">
        <span className="checkout-done__icon checkout-done__icon--bad"><XCircleIcon aria-hidden="true" /></span>
        <h1 className="checkout-done__title">Payment failed</h1>
        <p className="checkout-done__text">
          Your payment couldn't be processed. Your spot has not been reserved.
        </p>
        <Link to="/booking" className="bk-link">Back to calendar</Link>
      </div>
    );
  }

  // Payment is still processing (e.g. bank redirect)
  if (redirectStatus === 'processing') {
    return (
      <div className="bk-page bk-page--narrow checkout-done">
        <span className="checkout-done__icon checkout-done__icon--wait"><ClockIcon aria-hidden="true" /></span>
        <h1 className="checkout-done__title">Payment processing</h1>
        <p className="checkout-done__text">
          Your payment is being processed. Your booking will be confirmed shortly: check My bookings in a few minutes.
        </p>
        <Link to="/booking/my-bookings" className="bk-link">View my bookings</Link>
      </div>
    );
  }

  // Succeeded or free booking (no redirect params)
  return (
    <div className="bk-page bk-page--narrow checkout-done">
      <span className="checkout-done__icon"><CheckCircleIcon aria-hidden="true" /></span>
      <NotificationPrompt place="afterBooking" />
      <h1 className="checkout-done__title">Booking confirmed!</h1>
      <p>Your booking has been confirmed. See you on the trampoline!</p>
      <div className="checkout-done__links">
        <Link to="/booking/my-bookings" className="bk-link">View my bookings</Link>
        <Link to="/booking" className="bk-link">Back to calendar</Link>
      </div>
    </div>
  );
}
